import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { scrollToSection } from "@/lib/scroll";

export const Nosotros = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = "Nosotros - Ruta 360";
    if (location.hash === "#aventuras") {
      scrollToSection("aventuras");
    } else {
      const lenis = window.__lenis;
      if (lenis) lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div data-testid="nosotros-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[72px]">
        <Manifesto />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
};
